import React from 'react';

import { Content, Description, Header, Title } from './styles';
import MoreButton, { ListItem } from '../../MoreButton';

export interface Props {
  title: string;
  description?: string;
  maxWidth?: string;
  moreButtonData?: ListItem[] | null;
}

const ModalHeader: React.FC<Props> = ({
  title,
  description,
  maxWidth = 'none',
  moreButtonData,
}) => {
  return (
    <Header>
      <Content maxWidth={maxWidth}>
        <Title>
          <div>{title}</div> {moreButtonData?.length && <MoreButton items={moreButtonData} />}
        </Title>
        {description && <Description>{description}</Description>}
      </Content>
    </Header>
  );
};

export default ModalHeader;
